import React from "react";
import { motion } from "framer-motion";
import ScrollAnimation from "../../hooks/ScrollAnimation";
import { useTranslation } from "react-i18next";

export default function FaqContactSection() {
  const { t } = useTranslation();
  const faqItems = t("contact_page.faq.items", { returnObjects: true }) || [];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation direction="up" delay={0.1}>
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              style={{
                background: "linear-gradient(90deg,#0f172a 0%,#334155 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("contact_page.faq.title")}
            </motion.h2>
            <motion.p
              className="text-lg text-gray-600 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              {t("contact_page.faq.subtitle")}
            </motion.p>
          </div>
        </ScrollAnimation>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {faqItems.map((item, idx) => (
            <ScrollAnimation key={idx} direction="up" delay={0.06 * (idx + 1)}>
              <motion.div
                className="group relative rounded-2xl p-[1px] transition-all duration-300"
                whileHover={{ y: -4 }}
              >
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-slate-200 via-white to-slate-100" />
                <div className="relative z-10 rounded-2xl bg-white/90 backdrop-blur-xl p-6 shadow-[0_10px_25px_rgba(2,6,23,0.06)] ring-1 ring-slate-200">
                  <div className="flex items-start gap-4">
                    <div className="mt-1 grid place-items-center w-10 h-10 rounded-xl bg-blue-50 ring-1 ring-black/5">
                      <svg
                        className="w-5 h-5 text-blue-600"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M8 10h8M8 14h5"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="9"
                          stroke="currentColor"
                          strokeWidth="1.2"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">
                        {item.q}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                  <div className="mt-5 h-[2px] w-14 rounded-full bg-gradient-to-r from-blue-400 to-indigo-400 scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100" />
                </div>
              </motion.div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}
